import { EVENT_DELETED, EVENT_SAVED, openFavoriteSheet } from './favorite-sheet.js';

/**
 * The heart on a product card opens the product's favorite sheet and follows what is saved or deleted in it.
 */
document.addEventListener('click', async function (e) {
  const button = e.target.closest('.js_card_product__wishlist');
  if (!button) {
    return;
  }

  e.preventDefault();
  e.stopPropagation();

  if (!button.dataset.articleTypeId) {
    return;
  }

  const form = await openFavoriteSheet(button, new URLSearchParams({ articleTypeId: button.dataset.articleTypeId }));
  form?.addEventListener(EVENT_SAVED, () => setWishlistState(button, true));
  form?.addEventListener(EVENT_DELETED, () => setWishlistState(button, false));
});

function setWishlistState(button, active) {
  const icon = button.querySelector('.card_product__wishlist_icon');
  if (!icon) {
    return;
  }

  if (active) {
    icon.classList.add('card_product__wishlist_icon--active', 'lucide_icon--fill');
  } else {
    icon.classList.remove('card_product__wishlist_icon--active', 'lucide_icon--fill');
  }
}
